/* @flow */

import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import NavIconData from './nav-icon-data.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <NavIconData {...validProps} />;
}
SvgComponent.iconName = 'navIconData';

export const NavIconDataIcon = svgIconWrapper(SvgComponent);
